module.exports = __webpack_public_path__ + "img/solution9.b76a7a59.png";